import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { getAllActiveAlertsByType, getSmbOfSelectedTicket } from 'extractFromState';
import { alertsTypesMap } from 'constants/alerts';
import { getIconForAlert } from 'util/alertUtil';
import { setAlertManagerType } from 'actions/tools/ToolActions';
import { Container, BlueBar, HeaderSection, Title, Section, AlertButton } from 'components/tools/alerts/Alerts.styles';
import Alert from '../Alert/Alert';
import { InnerSection, SectionHeader } from './AllAlerts.styles';

class AllAlerts extends React.Component {
  handleCloseWindow = () => {
    this.props.setAlertManagerType(null);
  };

  getAlertTypeLabel = (alertType) => {
    return get(alertsTypesMap, `[${alertType}].label`, '');
  };

  renderAlertSection = ([alertType, alertList]) => {
    if (!alertList) {
      return null;
    }

    return (
      <React.Fragment key={alertType}>
        <InnerSection>
          <SectionHeader>
            <img src={getIconForAlert(alertType)} alt={alert.type} />
            <Title>{this.getAlertTypeLabel(alertType)} alerts</Title>
          </SectionHeader>
          {alertList.map((alert) => (
            <Alert key={alert.id} alert={alert} />
          ))}
        </InnerSection>
        <BlueBar />
      </React.Fragment>
    );
  };

  render() {
    const { alerts, partnerName } = this.props;

    return (
      <Container>
        <HeaderSection>
          <Title>All alerts for {partnerName}</Title>
          <AlertButton onClick={this.handleCloseWindow}>CLOSE</AlertButton>
        </HeaderSection>
        <Section>
          <BlueBar />
          {Object.entries(alerts).map((alert) => this.renderAlertSection(alert))}
        </Section>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  alerts: getAllActiveAlertsByType(state),
  partnerName: getSmbOfSelectedTicket(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setAlertManagerType,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AllAlerts);
